import LoadingCircle from '~components/Loading';
import { COMPANY_DETAIL_MENU } from '~constant/company';
import ModalJobdomEditor from '~features/board/ModalJobdomEditor';
import useGetCompanyInfo from '~hooks/query/company/useCompanyInfo';
import useGetCompanyStates from '~hooks/query/company/useCompanyStates';
import { useGetJobdomByCompanyQuery } from '~hooks/query/jobdom/useJobdom';
import { useRouterQuery } from '~hooks/useRouterQuery';
import useJobdomBoardStore from '~store/jobdom';
import { ValueOf } from '~types/common';

import BlockedInfo from '../BlockedInfo';
import Card from '../Card';
import ErrorSection from '../ErrorSection';
import ButtonMore from './ButtonMore';
import ButtonWriteBoard from './ButtonWriteBoard';
import EmptyJobdom from './EmptyJobdom';
import JobdomContainer from './JobdomContainer';
import * as S from './style';

export default function JobdomInfo({
  registerRef,
}: {
  registerRef: (element: HTMLElement, id: ValueOf<typeof COMPANY_DETAIL_MENU>) => void;
}) {
  const companyId = useRouterQuery('companyId');
  const {
    data: posts,
    status: statusPosts,
    refetch: refetchPosts,
  } = useGetJobdomByCompanyQuery(companyId);
  const { data: companyStates, status: statusCompanyStates } = useGetCompanyStates(companyId);
  const { data: companyInfo, status: statusCompanyInfo } = useGetCompanyInfo(companyId);
  const { modalJobdomEditor, resetModalJobEditor } = useJobdomBoardStore();

  const handlwClickReaction = () => {
    refetchPosts();
  };

  const cardProps = {
    sectionId: COMPANY_DETAIL_MENU.COMMUNITY,
    title: 'JOB담',
    registerRef,
  };

  if (companyStates?.deleted) {
    return null;
  }

  if (statusPosts === 'error') {
    return (
      <Card {...cardProps}>
        <ErrorSection />
      </Card>
    );
  }

  if (statusPosts === 'loading' || !companyInfo) {
    return (
      <Card {...cardProps}>
        <LoadingCircle />
      </Card>
    );
  }

  if (
    statusPosts !== 'success' ||
    statusCompanyStates !== 'success' ||
    statusCompanyInfo !== 'success' ||
    companyStates?.deleted
  ) {
    return null;
  }

  return (
    <Card {...cardProps} rightCardHeader={companyStates?.board && <ButtonWriteBoard />}>
      {!companyStates?.board ? (
        <BlockedInfo />
      ) : (
        <>
          {posts.rows.length === 0 ? (
            <EmptyJobdom />
          ) : (
            <>
              <JobdomContainer
                posts={posts.rows}
                postCount={posts.count}
                companyName={companyInfo?.name}
                companyId={companyInfo.id}
                PK_NM_HASH={companyId}
                onClickReaction={handlwClickReaction}
              />
              <S.ButtonWrapper>
                <ButtonMore
                  postId={companyId}
                  postCount={posts.count}
                  data-attribute-id='company__board__seeMore'
                  data-company-name={companyInfo?.name}
                  data-board-count={posts?.count}
                />
              </S.ButtonWrapper>
            </>
          )}

          {modalJobdomEditor.open && (
            <ModalJobdomEditor
              isOpen
              handleClose={() => resetModalJobEditor()}
              defaultValues={modalJobdomEditor}
            />
          )}
        </>
      )}
    </Card>
  );
}
